import { useMsal } from "@azure/msal-react";
import type { AccountInfo } from "@azure/msal-browser";
import { emailIsInternal } from "@multiconsult-group/multiplacer-core";

const getAccountEmail = (account: AccountInfo | null) => {
  if (!account) return "";
  return String((account.idTokenClaims as any)?.preferred_username ?? account.username ?? "");
};

export const useInternalMsalAccount = () => {
  const { instance } = useMsal();
  const account = instance.getActiveAccount() ?? instance.getAllAccounts()[0] ?? null;
  const email = getAccountEmail(account);
  return email ? emailIsInternal(email) : false;
};
